import React, { createContext, useContext, useState } from 'react';
import { ACCOUNTS, DEFAULT_ACCOUNT_ID, type Account } from '../data/accounts';
interface AccountContextValue {
  account: Account;
  setAccountId: (id: string) => void;
}
const defaultAccount = ACCOUNTS.find(a => a.id === DEFAULT_ACCOUNT_ID) ?? ACCOUNTS[0];
const AccountContext = createContext<AccountContextValue>({
  account: defaultAccount,
  setAccountId: () => {}
});

/** The signed-in person — will scope analytics to their role. */
export function AccountProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [accountId, setAccountId] = useState(DEFAULT_ACCOUNT_ID);
  const account = ACCOUNTS.find(a => a.id === accountId) ?? defaultAccount;
  return <AccountContext.Provider value={{
    account,
    setAccountId
  }} data-id="element-6407" data-mp="r3dy2a2ij3st">
      {children}
    </AccountContext.Provider>;
}
export function useAccount() {
  return useContext(AccountContext);
}